"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var Button = function (props) {
    var _a = props || {}, children = _a.children, inProgress = _a.inProgress, size = _a.size, indicator = _a.indicator, rest = __rest(_a, ["children", "inProgress", "size", "indicator"]);
    var progressSize = 28;
    switch (size) {
        case "small":
            progressSize = 22;
            break;
        case "large":
            progressSize = 34;
            break;
        default:
            break;
    }
    if (indicator) {
        react_1.default.cloneElement(indicator, { size: progressSize });
    }
    return (react_1.default.createElement(core_1.Button, __assign({}, rest, { size: size }),
        children,
        inProgress && (react_1.default.createElement("div", { style: { position: "absolute", top: "4px" } },
            react_1.default.createElement(core_1.CircularProgress, { size: progressSize })))));
};
Button.propTypes = {
    children: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.string]),
    inProgress: prop_types_1.default.bool,
    size: prop_types_1.default.string
};
exports.default = Button;
